import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Sparkles } from "lucide-react";

interface AiProgressDialogProps {
  open: boolean;
  progress: number;
}

export function AiProgressDialog({ open, progress: _progress }: AiProgressDialogProps) {
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-md" onPointerDownOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Sparkles className="h-5 w-5 animate-pulse" />
            Generating Schedule with AI
          </DialogTitle>
          <DialogDescription>Please wait while AI creates your crew schedule...</DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4 text-center">
          <div className="flex justify-center">
            <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-primary"></div>
          </div>
          <p className="text-lg font-medium text-foreground">Generating...</p>
          <p className="text-sm text-muted-foreground">AI is creating your crew schedule</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
